(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  // Hortus Home: Höhe der fixierten Ankündigungsleiste messen, damit der Header darunter andockt
  (() => {
    const bar = document.querySelector('.hh-ann-sticky');
    if (!bar) return;
    const set = () => document.body.style.setProperty('--hh-ann-height', `${bar.getBoundingClientRect().height}px`);
    set();
    if ('ResizeObserver' in window) new ResizeObserver(set).observe(bar);
    window.addEventListener('resize', set, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-popup"] && !Shopify.designMode) return;
  try {
    
  // Hortus Home: Pop-up – einmal, zeitverzögert, respektiert Schließen für 14 Tage
  if (!customElements.get('hh-popup')) {
    customElements.define('hh-popup', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        const KEY = 'hh-popup-closed';
        const success = this.querySelector('[data-hh-success]');
        const errors = this.querySelector('.hh-popup__error');
        this.querySelectorAll('[data-hh-close]').forEach((b) => b.addEventListener('click', () => this.dialog.close()));
        this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.dialog.close(); });
        this.dialog.addEventListener('close', () => { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} });
        // Nach dem Absenden: Ergebnis sofort zeigen
        if (success || errors) { this.dialog.showModal(); return; }
        if (window.Shopify && window.Shopify.designMode) return;
        let last = 0;
        try { last = parseInt(localStorage.getItem(KEY) || '0', 10); } catch (e) {}
        if (Date.now() - last < 14 * 24 * 3600 * 1000) return;
        const delay = Math.max(3, parseInt(this.dataset.delay, 10) || 8) * 1000;
        setTimeout(() => { if (!document.querySelector('dialog[open]')) this.dialog.showModal(); }, delay);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-reviews"] && !Shopify.designMode) return;
  try {
    
  // Hortus Home: Bewertungen als Endlosschleife (dupliziert die Karten einmal)
  if (!customElements.get('hh-marquee')) {
    customElements.define('hh-marquee', class extends HTMLElement {
      connectedCallback() {
        if (this.classList.contains('hh-reviews__marquee--off')) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (window.Shopify && window.Shopify.designMode) return;
        const track = this.querySelector('[data-hh-track]');
        if (!track || track.dataset.cloned) return;
        [...track.children].forEach((el) => {
          const c = el.cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          c.querySelectorAll('a, button').forEach((f) => f.setAttribute('tabindex', '-1'));
          track.appendChild(c);
        });
        track.dataset.cloned = 'true';
        this.classList.add('is-running');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
